import { Home } from "./types";
import { createSlice } from "@reduxjs/toolkit";

interface HomeState {
  data: {
    dataHome: Home; // Replace 'any' with a more specific type if possible
  };
}

const HomeSlice = createSlice({
  name: 'Home',
  initialState: { data: { dataHome: {} } } as HomeState,
  reducers: {
    setDataHome: (state, action) => {
      state.data.dataHome = action.payload;
    },
  },
});

export const { setDataHome } = HomeSlice.actions;
export const HomeReducer = HomeSlice.reducer;